import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ImgContainFit, ImgCover, ImgWH } from '@pages/CommonStyle/common.style';

export const RecommendLayout = styled.div`
  padding-top: 96px;
  padding-bottom: 64px;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding-top: 64px;
  }
`;

export const ReommendSlider = styled.div`
  position: relative;
  overflow: hidden;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    padding-bottom: 24px;

    gap: 32px;
    & > div {
      scroll-snap-align: start;
      flex: 0 0 auto;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const RecommendImg = styled.img<{ fade: boolean }>`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  transition: opacity 0.4s ease-in-out;
  opacity: ${({ fade }) => (fade ? 1 : 0)};
`;

export const RecommendSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;

  /* 이미지 영역: 부모 폭의 60% 고정 */
  & > div:first-of-type {
    flex: 0 0 60%;
  }
  /* 텍스트 영역: 나머지 */
  & > div:last-of-type {
    flex: 1;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex-direction: column;
    gap: 0px;
    width: 300px;
  }
`;

export const RecommendImage = styled.div`
  aspect-ratio: 808 / 540;
  max-width: 60%;
  border-radius: 16px;

  border: 1px solid rgba(82, 12, 12, 0.08);

  overflow: hidden;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    background-color: #e9e9e9;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    border: 0px;

    height: 193px;
    max-width: 100%;
  }
`;

export const FadingImage = styled(ImgCover)<{ fade: boolean }>`
  opacity: ${(props) => (props.fade ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;

export const RecommendTextLayout = styled.div`
  display: flex;
  flex-direction: column;
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 0 24px;
    background-color: #f8f8f8;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    flex: 1;
    min-height: 400px;
  }
`;

export const Space = styled.div`
  height: auto;
  flex: 1;
`;

export const RecommendTextBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    justify-content: space-between;
  }
`;

export const RecommendButtonBox = styled.div`
  margin-top: auto;
  gap: 8px;
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const RecommendButton = styled.div`
  padding: 12px;
  border: 1px solid #000;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
`;

export const RecommendMore = styled.a`
  padding: 16px 32px;
  border: 1px solid #000;
  border-radius: 12px;
  width: fit-content;
  height: fit-content;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;
